import React, { useState } from 'react'
import { Box, Checkbox, Button, Typography } from "@material-ui/core";
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import {Documentos} from '../componentes/Documentos';

export const AceptacionDocsCheck = ({ iniciarContinuar, cancelar, documento,setDocumento,lecturas,setLecturas }) => {

  const documentos = [
    { id: 'estatutos', label: 'Testimonio y Estatutos de la Unión de las Asambleas de Dios' },
    { id: 'doctrina', label: 'Doctrinas Fundamentales de la Unión de las Asambleas de Dios' },
    { id: 'compromiso', label: 'Compromiso Ministerial de la Unión de las Asambleas de Dios' }
  ];

  const [checks, setChecks] = useState({
    doctrina: false,
    estatutos: false,
    compromiso: false
  });

  const handleCheck = (campo) => (e) => {
    setChecks(prev => ({
      ...prev,
      [campo]: e.target.checked
    }));
  };

  const todosAceptados =
    checks.doctrina && checks.estatutos && checks.compromiso;


  const handleAceptar = ()=>{
    if (todosAceptados){
        iniciarContinuar();
    }
  }  
  return (
    <Box sx={{ marginTop: '40px', maxWidth: '720px', marginInline: 'auto' }}>
      
    <Documentos
        setDocumento={setDocumento}
        documento={documento}
        lecturas = {lecturas}
        setLecturas = {setLecturas}
    /> 

      {/* TITULO */}
      <Typography 
        variant="h5" 
        className="text-center font-semibold text-gray-800"
      >
        Aceptación de documentos
      </Typography>

      {/* SUBTEXTO */}
      <p className="text-center text-gray-500 mt-6">
        Por favor revise y acepte cada uno de los siguientes documentos:
      </p>

      {/* LISTADO */}
      <div className="space-y-3 mt-6">

        {documentos.map((doc) => (
          <div 
            key={doc.id}
            className={`
              flex items-center justify-between 
              px-4 py-3 rounded-lg border transition-all
              ${checks[doc.id] 
                ? 'border-green-300 bg-green-50' 
                : 'border-gray-200 hover:border-blue-400 hover:bg-blue-50'}
            `}
          >

            {/* IZQUIERDA */}
            <div className="flex items-center gap-3">
              <Checkbox
                checked={checks[doc.id]}
                onChange={handleCheck(doc.id)}
                color="primary"
              />

              <span className="text-sm text-gray-800 leading-tight">
                {doc.label}
              </span>

              {/* OPCIONAL: estado visual */}
              {checks[doc.id] && (
                <span className="text-green-600 text-xs font-semibold ml-2">
                  ✓ Aceptado
                </span>
              )}
            </div>

            {/* DERECHA */}
            <button
              type="button"
              onClick={() => setDocumento(doc.id)}
              className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-medium"
            >
              <BrowserUpdatedIcon fontSize="small" />
              Ver
            </button>

          </div>
        ))}

      </div>

      {/* BOTONES */}
      <div className="mt-12 flex flex-col sm:flex-row justify-center gap-6">
        <Button 
          variant="text"
          onClick={cancelar}
          className="flex items-center gap-2 text-gray-600 hover:bg-gray-100 rounded-lg px-3 py-1"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          Volver
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleAceptar}
          title={`${todosAceptados ? '' : 'Acepte todos los documentos para continuar' }`}
          style={{cursor: todosAceptados ? 'pointer' : 'not-allowed'}}
          className={`px-10 py-2 rounded-lg shadow-sm ${!todosAceptados ? 'opacity-10 cursor-not-allowed' : '' }`}
        >
          Continuar
        </Button>

      </div>
     <p className="text-center text-gray-500 mt-6">
        Al hacer clic en Continuar declara haber leído y aceptado los documentos institucionales de la UAD
      </p>
    </Box>
  );
};